var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { cx, css as emotionCss } from 'emotion';
import { SectionTitleActionArea, SectionTitleH1, SectionTitleH2, SectionTitleH3, SectionTitleWrapper, } from './Layout.styled';
import { collapse, sectionTitleActionWrapperBreakpoints } from '../styles/legacy';
import { getAutomation, getDebug, getStyleNames } from '@citrus/runtime';
import { capitalize, isNotNilOrEmpty } from '@pcty/utils';
var VERSION = '6.7.2';
var SectionTitle = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var actionAreaBreakpoint = _a.actionAreaBreakpoint, as = _a.as, automationId = _a.automationId, children = _a.children, className = _a.className, css = _a.css, renderActionArea = _a.renderActionArea, __TYPE = _a.__TYPE, other = __rest(_a, ["actionAreaBreakpoint", "as", "automationId", "children", "className", "css", "renderActionArea", "__TYPE"]);
    var Component = getSectionTitleStyled(as);
    var emotionObj = (_b = {},
        _b[emotionCss(collapse.xs)] = actionAreaBreakpoint === 'xs',
        _b[emotionCss(collapse.sm)] = actionAreaBreakpoint === 'sm',
        _b[emotionCss(collapse.md)] = actionAreaBreakpoint === 'md',
        _b[emotionCss(css)] = isNotNilOrEmpty(css),
        _b);
    var classes = cx(emotionObj, className || '');
    var styleNames = (_c = {},
        _c['collapse' + capitalize(actionAreaBreakpoint !== null && actionAreaBreakpoint !== void 0 ? actionAreaBreakpoint : '')] = actionAreaBreakpoint
            ? emotionObj[emotionCss(collapse[actionAreaBreakpoint])]
            : false,
        _c);
    return (React.createElement(SectionTitleWrapper, __assign({ className: classes, ref: ref, styleNames: getStyleNames(styleNames) }, other, getAutomation(automationId), getDebug(sessionStorage.getItem('citrus-debug') === 'true', __TYPE, VERSION)),
        React.createElement(Component, null, children),
        _renderActionArea(renderActionArea, actionAreaBreakpoint)));
});
var _renderActionArea = function (renderActionArea, actionAreaBreakpoint) {
    var _a, _b;
    if (!renderActionArea)
        return;
    var actionArea = renderActionArea();
    if (isNotNilOrEmpty(actionArea)) {
        var emotionObj = (_a = {},
            _a[emotionCss(sectionTitleActionWrapperBreakpoints.xs)] = actionAreaBreakpoint === 'xs',
            _a[emotionCss(sectionTitleActionWrapperBreakpoints.sm)] = actionAreaBreakpoint === 'sm',
            _a[emotionCss(sectionTitleActionWrapperBreakpoints.md)] = actionAreaBreakpoint === 'md',
            _a);
        var classes = cx(emotionObj);
        var styleNames = (_b = {},
            _b['sectionTitleActionWrapperBreakpoints' + capitalize(actionAreaBreakpoint)] = emotionObj[emotionCss(sectionTitleActionWrapperBreakpoints[actionAreaBreakpoint])],
            _b);
        return (React.createElement(SectionTitleActionArea, { className: classes, styleNames: getStyleNames(styleNames) }, actionArea));
    }
};
SectionTitle.defaultProps = {
    __TYPE: 'SectionTitle',
};
var getSectionTitleStyled = function (as) {
    if (as === 'h1') {
        return SectionTitleH1;
    }
    else if (as === 'h2') {
        return SectionTitleH2;
    }
    return SectionTitleH3;
};
export default SectionTitle;
